import http from '../../services/http-common';

class CompanyService {
  getCompanyForList(id) {
    return http.get(`/Company/db/table/${id}`);
  }
  insert(data) {
    return http.post(`/Company/db/add`, data);
  }
  update(data) {
    return http.put(`/Company/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/Company/db/delete/${PropertyID}`);
  }
}

export default new CompanyService();